import { DARK_MODE } from "./dark-mode";

export const Gitlab = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <style>{DARK_MODE}</style>
    <g clipPath="url(#clip0_505_1689)">
      <path
        d="M15.7337 6.39379L15.7112 6.33631L13.5335 0.652895C13.4892 0.541503 13.4107 0.447009 13.3094 0.382971C13.2079 0.32002 13.0897 0.289702 12.9705 0.296108C12.8513 0.302514 12.7369 0.345337 12.6429 0.418794C12.5498 0.494361 12.4824 0.596756 12.4496 0.712045L10.9792 5.21079H5.02499L3.55457 0.712045C3.52268 0.596128 3.45505 0.49322 3.36129 0.417961C3.26722 0.344503 3.15287 0.301681 3.03368 0.295274C2.9145 0.288868 2.79622 0.319187 2.69481 0.382138C2.5937 0.446435 2.51531 0.540846 2.47071 0.652062L0.288816 6.33298L0.267156 6.39046C-0.046338 7.20957 -0.0850337 8.1084 0.156903 8.95142C0.39884 9.79444 0.908292 10.536 1.60845 11.0642L1.61595 11.07L1.63594 11.0842L4.95335 13.5685L6.59456 14.8106L7.59428 15.5654C7.71122 15.6542 7.85401 15.7023 8.00083 15.7023C8.14766 15.7023 8.29045 15.6542 8.40739 15.5654L9.40711 14.8106L11.0483 13.5685L14.3857 11.0692L14.3941 11.0625C15.0926 10.5342 15.6009 9.79344 15.8425 8.95156C16.084 8.10967 16.0459 7.21213 15.7337 6.39379Z"
        fill="#E24329"
      />
      <path
        d="M15.7336 6.39379L15.7111 6.3363C14.65 6.55411 13.6501 7.00358 12.7828 7.6526L7.99994 11.2691C9.62865 12.5013 11.0466 13.5718 11.0466 13.5718L14.384 11.0725L14.3923 11.0658C15.0919 10.5375 15.601 9.79631 15.8429 8.9537C16.0848 8.1111 16.0464 7.21272 15.7336 6.39379Z"
        fill="#FC6D26"
      />
      <path
        d="M4.95331 13.5718L6.59452 14.8139L7.59424 15.5687C7.71118 15.6575 7.85397 15.7056 8.00079 15.7056C8.14762 15.7056 8.29041 15.6575 8.40735 15.5687L9.40707 14.8139L11.0483 13.5718C11.0483 13.5718 9.62867 12.4979 7.99996 11.2691C6.37125 12.4979 4.95331 13.5718 4.95331 13.5718Z"
        fill="#FCA326"
      />
      <path
        d="M3.21633 7.65262C2.34974 7.00226 1.35002 6.55163 0.288816 6.33299L0.267156 6.39048C-0.046338 7.20959 -0.0850337 8.10841 0.156903 8.95143C0.398839 9.79446 0.908292 10.536 1.60845 11.0642L1.61595 11.07L1.63594 11.0842L4.95335 13.5685C4.95335 13.5685 6.36962 12.4979 8 11.2658L3.21633 7.65262Z"
        fill="#FC6D26"
      />
    </g>
    <defs>
      <clipPath id="clip0_505_1689">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
